import handleAccountActionResponse from "./handle-account-action-response.js";
import switchToRegistrationMode from "./switch-to-registration-mode.js";
import {closePasswordForm, passwordRenewSuccess} from "./password-controller.js";
import {authElements} from "./auth-account-elements.js";


/**
 * Инициализирует глобальный слушатель событий postMessage.
 * Ожидание ответа после отправки формы из handleAuthSubmit.
 * Дальнейшее действие в зависимости от event.data.action.
 *
 * @returns {void}
 */

export default function initAuthMessageListener() {
    /**
     * Глобальный слушатель событий postMessage.
     *
     * @param {MessageEvent} event - Объект события сообщения
     * @param {Object} event.data - Тело переданного сообщения
     * @param {string} event.data.action - Идентификатор действия (например, 'handleAccountActionResponse')
     * @param {*} [event.data.payload] - Полезная нагрузка для действий авторизации и регистрации
     * @param {number|string} [event.data.id] - ID пользователя (только для действия ttAuthPasswordRenewSuccess)
     * @param {string} [event.data.hc] - Секретный хэш/код (только для действия ttAuthPasswordRenewSuccess)
     * @returns {void}
     */
    window.addEventListener('message', (event) => {
        if (!event.data || !event.data.action) return;

        switch (event.data.action) {

            // авторизация: успешный вход или ошибки (например не указан пароль, пользователь не найден)
            // регистрация: если не указано подтверждение пароля, обработает ошибки
            case 'handleAccountActionResponse':
                handleAccountActionResponse(event.data.payload);
                break;

            // регистрация (если было указано поле подтверждение пароля)
            case 'switchToRegistrationMode':
                if (event.data.payload === 2) {
                    if (authElements.ttAuthName) {
                        authElements.ttAuthName.style.display = 'block';
                    }
                    switchToRegistrationMode(2);
                }
                break;

            // вызывается при успешном сохранении измененных данных профиля пользователя (включая смену пароля).
            case 'closePasswordForm':
                closePasswordForm();
                break;

            // вызывается при успешном восстановлении (сбросе) пароля пользователя по специальной ссылке
            case 'passwordRenewSuccess':
                const userId = event.data.id;
                const userHc = event.data.hc;
                passwordRenewSuccess(userId, userHc);
                break;
        }
    });
}